<template>
  <div id="LuojiaSwarm">
    <div class="font">
      <span class="introSubTitle"><b>无人机集群全自动测图系统 LuojiaSwarm</b></span>
      <p class="textStyle">研制了多机型适配、多载荷配置、灵活轻量、跨区域超视距的无人机集群全自动测绘系统，该系统具备一键起飞、多机观测、自主飞行、自动收发、实时成图的全自动能力，具备智能规划、平面成图、三维重建、重点目标立面精细测图、边飞-边传-边成图、目标检测跟踪等多任务并行工作能力，具备GNSS拒止条件下的无人机自主测图能力，并可与北斗通信、高通量卫星等通信系统集成。系统可以搭配无人值守机巢中的无人机使用，也可以适配独立的无人机，同时还支持机巢和独立无人机组合的混成集群系统。</p>
    </div>
    <!-- <br/>   -->
    
    <img width="100%" src="@/assets/img/scientific/LuojiaSwarm1.png" />
    <!--    <p class="img_figure">轻小型无人机机巢</p>     -->
    <img width="100%" src="@/assets/img/scientific/LuojiaSwarm2.png" />
<!--    <p class="img_figure">航线规划</p>    -->
    <!-- <div class="container">
      <my-video :sources="video.sources" :options="video.options"></my-video>
    </div> -->
  </div>
</template>

<script>
// import myVideo from "vue-video";

export default {
  data() {
    return {
      // video: {
      //   sources: [
      //     {src: require("@/assets/static/Quick_change.mp4"), type:"video/mp4"},
      //   ],
      //   options: {
      //     autoplay: true,
      //     volume: 0.6,
      //   },
      // },
    };
  },
  // components: {
  //   myVideo,
  // },
};
</script>

<style lang="less">
#LuojiaSwarm {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #4f4f4f;
  }
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
